import script from "./DocumentsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentsPage.vue?vue&type=script&setup=true&lang=js"

import "./DocumentsPage.vue?vue&type=style&index=0&id=efbbac7a&lang=css"

const __exports__ = script;

export default __exports__